import React from 'react';
import cx from 'clsx';
import { AttentionBox } from '@kcd/design-system';

type Props = {
  quantity?: number;
  className?: string;
};
function DeliveryFeePerQuantityNotice({ quantity, className }: Props) {
  if (!quantity) return null;
  return (
    <div className={cx(['px-20 mt-8', className])}>
      <AttentionBox
        description={`${quantity}개당 배송비가 추가 부과됩니다.`}
        hideDismiss
      />
    </div>
  );
}

export default DeliveryFeePerQuantityNotice;
